import * as z from 'zod/v4';
import { validationSchema } from '../../types';
import { TRANSLATION_TYPES } from '../../types/translations';
import { userSchema } from '../users/users.schemas';

export const translationSchema = z.object({
  id: z.uuid(),
  type: z.enum(TRANSLATION_TYPES),
  key: z.string(),
  title: z.string(),
  values: z.record(z.string(), z.string()),
  createdAt: z.coerce.date(),
  description: z.string().optional().nullable(),
  lastUpdatedAt: z.coerce.date(),
  lastModifiedBy: userSchema.pick({ name: true, email: true, id: true }),
});

export const createTranslationSchema = validationSchema({
  body: translationSchema.omit({
    id: true,
    createdAt: true,
    lastUpdatedAt: true,
    lastModifiedBy: true,
  }),
  response: {
    201: z.object({
      translation: translationSchema.omit({ lastModifiedBy: true }),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const updateTranslationSchema = validationSchema({
  params: z.object({
    id: z.uuid(),
  }),
  body: translationSchema
    .omit({
      id: true,
      createdAt: true,
      lastUpdatedAt: true,
      lastModifiedBy: true,
    })
    .partial(),
  response: {
    200: z.object({
      translation: translationSchema.omit({ lastModifiedBy: true }),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const getTranslationsSchema = validationSchema({
  querystring: z.object({
    search: z.string().optional(),
    page: z.coerce.number().optional(),
    pageSize: z.coerce.number().optional(),
    type: z.enum(['inline', 'image']).optional(),
  }),
  response: {
    200: z.object({
      translations: z.array(translationSchema),
      total: z.number(),
      totalPages: z.number(),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const deleteTranslationSchema = validationSchema({
  params: z.object({
    id: z.uuid(),
  }),
  response: {
    204: z.void(),
    200: z.object({
      warning: z.string(),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const getTranslationSchema = validationSchema({
  params: z.object({
    id: z.uuid(),
  }),
  response: {
    200: z.object({
      translation: translationSchema,
    }),
    404: z.object({
      errorMessage: z.string(),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const translateSchema = validationSchema({
  querystring: z.object({
    key: z.string(),
    languages: z.array(z.string()),
  }),
  response: {
    200: z.object({
      translation: z.record(z.string(), z.string()),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});
